import { parse } from "query-string";
import { has } from "lodash";

export type ToggleState = {
  [F in FeatureToggles]: boolean;
};

export enum FeatureToggles {
  BANK_INTEGRATION_DETAILS = "bank-integration-details",
  TRANSACTIONS_FILTER = "transactions-filter",
  REJECT_KYC = "reject-kyc",
  RESUBMIT_DOCS = "resubmit-docs",
  ESPAY = "espay",
  USER_LIST = "user-list",
}

// TODO: Check and remove toggle inside code after the feature fully published and stable
const mappingConfigToToggles: Record<string, FeatureToggles> = {
  toggleTransactionsFilter: FeatureToggles.TRANSACTIONS_FILTER,
  toggleBankIntegrationDetails: FeatureToggles.BANK_INTEGRATION_DETAILS,
  toggleRejectKyc: FeatureToggles.REJECT_KYC,
  toggleResubmitDocs: FeatureToggles.RESUBMIT_DOCS,
  toggleEspay: FeatureToggles.ESPAY,
  toggleUserList: FeatureToggles.USER_LIST,
};

const featureTogglesForQuery: string[] = [
  // List of feature toggles that could be enabled via query params
  FeatureToggles.TRANSACTIONS_FILTER,
  FeatureToggles.BANK_INTEGRATION_DETAILS,
  FeatureToggles.ESPAY,
];

const getQueryParam = (key: string): string => {
  const locationSearch = parse(window.location.search);
  return locationSearch[key] as string;
};

const getTogglesFromConfig = (config: Record<string, string>): ToggleState => {
  const toggles: ToggleState = {} as ToggleState;
  Object.keys(config).forEach((key) => {
    if (key.startsWith("toggle") && has(mappingConfigToToggles, key)) {
      toggles[mappingConfigToToggles[key]] = config[key] == "true";
    }
  });
  return toggles;
};

const getTogglesFromQuery = (): ToggleState => {
  const toggles: ToggleState = {} as ToggleState;
  const togglesQuery = getQueryParam("toggles");
  if (togglesQuery) {
    const togglesArr = togglesQuery.split(",") as FeatureToggles[];
    togglesArr.forEach((toggle) => {
      if (featureTogglesForQuery.includes(toggle as FeatureToggles)) {
        toggles[toggle] = true;
      }
    });
  }

  return toggles;
};

export const getToggles = (config: Record<string, string>): ToggleState => {
  return {
    ...getTogglesFromConfig(config),
    ...getTogglesFromQuery(),
  };
};
